
import { Component, Emit, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
/**
 * デモサイトにおいて、退出時の確認ポップアップ。
 */
@Component({ components: { Popup } })
export default class LeaveRoomPopup extends Vue {
  @Emit('onCancel')
  onCancel() {}
  @Emit('onLeaveRoom')
  onLeaveRoom() {}
}
